module.exports = __webpack_public_path__ + "img/ic_live_item3.59a25ac2.png";